import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import { Constants, Globals } from '../../../utils';

function parse(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

function getBillNumber(order) {
  const isFiscalBill = order?.fiscal_bill === Constants.ORDERS.FISCAL_BILL.YES;
  const isFiscalBillFree = order?.fiscal_bill_free === Constants.ORDERS.FISCAL_BILL_FREE.YES;

  return isFiscalBill
    ? order?.order_bill?.bill_number
    : (isFiscalBillFree ? order?.bill_number_format : '');
}

class ModalViewDebit extends Component {

  state = {
    visible_products: false,
    debitedItem: Globals.copy(this.props.debitedItem),
    totals: {
      subtotal_usd: 0,
      subtotal_bs: 0,
      paid_usd: 0,
      paid_bs: 0,
      left_usd: 0,
      left_bs: 0,
      total_bs: 0,
      total_usd: 0,
      change_bs: 0,
      change_usd: 0,
      iva_8_bs: 0,
      iva_8_usd: 0,
      iva_16_bs: 0,
      iva_16_usd: 0,
      iva_31_bs: 0,
      iva_31_usd: 0,
      iva_bs: 0,
      iva_usd: 0,
      igtf_bs: 0,
      igtf_usd: 0,
      discount_bs: 0,
      discount_usd: 0,
      diff_usd: 0,
      diff_bs: 0,
    },
    exchangeRate: 0,
  }

  componentDidMount() {
    this.formatOrder();
  }

  formatOrder = async () => {
    console.log('this.state.debitedItem: ', this.state.debitedItem)
    const exchangeRate = parseFloat(this.state.debitedItem.conversion) || 0;

    const formatProduct = (item) => {
      if (!item) return;

      const originalPrice = item.price;
      const price = item.price ?? item.selected_price ?? item.sale_price;

      if (item.product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = item.product?.size_colors.find(sc => sc.id === item.size_color_id);

        if (!!size_color?.color) item.product.name += `, ${size_color.color.name}`;
        if (!!size_color?.size) item.product.name += `, ${size_color.size.name}`;
      }

      return {
        ...item,
        isPermanent: true,
        originalQuantity: Number(item.quantity),
        originalPrice,
        price,
        price_bs: price * exchangeRate,
        sale_price: price,
        selected_price: price,
      }
    }

    await this.setState(s => ({
      exchangeRate,
      debitedItem: {
        ...s.debitedItem,
        details: s.debitedItem.details?.map(formatProduct),
      },
    }));

    //this.setTotals();
  }

  convert = (value) => {
    return value * (this.state.debitedItem.conversion);
  }

  setTotals = async () => {
    const { debitedItem } = this.state;
    const exchangeRate = this.state.exchangeRate || 0;

    let subtotal_without_disc_usd = 0;
    let subtotal_without_disc_bs = 0;
    let subtotal_usd = 0;
    let subtotal_bs = 0;
    let left_usd = 0;
    let left_bs = 0;
    let total_bs = 0;
    let total_usd = 0;
    let change_bs = 0;
    let change_usd = 0;
    let iva_bs = 0;
    let iva_usd = 0;
    let iva_8_bs = 0;
    let iva_8_usd = 0;
    let iva_16_bs = 0;
    let iva_16_usd = 0;
    let iva_31_bs = 0;
    let iva_31_usd = 0;
    let igtf_bs = 0;
    let igtf_usd = 0;
    let total_taxes_usd = 0;

    const products = [...debitedItem.details];
    const paid_usd = parse(debitedItem.payment_methods?.reduce((acc, curr) => acc + Number(curr.amount), 0));
    const paid_bs = parse(debitedItem.payment_methods?.reduce((acc, curr) => acc + Number(curr.amount_bs), 0));

    for (const product of products) {
      let iva_product = 0
      const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES ? product.quantity : parseInt(product.quantity)
      const price = product?.price ?? product.sale_price;
      const iva = product?.product?.iva ?? product.iva;
      const ivaPercentage = product?.product?.iva_porcentage ?? 0;
      const subtotalWithoutDiscount = parse(qty * price);
      const discountPercentage = product.discount_percentage ?? product.discount;
      const discountAmount = discountPercentage > 0
        ? (subtotalWithoutDiscount * discountPercentage) / 100
        : 0;
      const total = parse(subtotalWithoutDiscount - discountAmount);
      subtotal_usd += total;

      product.subtotal = subtotalWithoutDiscount;
      product.discount = discountAmount;
      product.total = total;

      //si el producto no es exento de IVA lo agrego al calculo
      if (product?.product?.exento == Constants.PRODUCT_EXENTO.NO) {
        iva_product = ((product.total * ivaPercentage) / 100)
        product.iva_usd = iva_product
        iva_usd += iva_product

        if (iva === Constants.PRODUCT_IVA.DIECISEIZ) {
          iva_16_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.OCHO) {
          iva_8_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.TREINTAIUNO) {
          iva_31_usd += iva_product;
        }
      }
    }

    // Subtotal sin descuentos
    subtotal_without_disc_usd = subtotal_usd;
    subtotal_without_disc_bs = parse(subtotal_without_disc_usd * exchangeRate);

    // Descuentos globales
    let discountAmount = 0;
    let ivaDiscountAmount = 0;
    if (debitedItem.discount_percentage > 0) {
      discountAmount = (subtotal_usd * debitedItem.discount_percentage) / 100;
      ivaDiscountAmount = (iva_usd * debitedItem.discount_percentage) / 100;
    }
    iva_usd -= ivaDiscountAmount;
    subtotal_usd -= discountAmount;
    subtotal_bs = parse(subtotal_usd * exchangeRate);

    //Impuestos
    //IVA
    iva_bs = parse(iva_usd * exchangeRate);
    iva_8_bs = parse(iva_8_usd * exchangeRate);
    iva_16_bs = parse(iva_16_usd * exchangeRate);
    iva_31_bs = parse(iva_31_usd * exchangeRate);
    iva_usd = parse(iva_usd)
    total_taxes_usd = parse(iva_usd);
    total_usd = parse(subtotal_usd + total_taxes_usd);

    //IGTF
    const hasIGTF = debitedItem.payment_methods?.some(method => !Constants.LOCAL_CURRENCIES.includes(method.method_id));
    if (hasIGTF) {
      igtf_usd = parse((total_usd * Constants.TAXES.IGTF) / 100);
      igtf_bs = parse(igtf_usd * exchangeRate);
      total_usd = parse(total_usd + igtf_usd);
    }
    total_bs = parse(total_usd * exchangeRate);

    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);

    if (left_usd < 0) {
      change_usd = parse(left_usd * -1);
      change_bs = parse(change_usd * exchangeRate);
      left_usd = parse(0);
      left_bs = parse(0);
    }

    const diff_usd = parse(total_usd - this.props.debitedItem.total);
    const diff_bs = parse(diff_usd * exchangeRate);

    await this.setState(s => ({
      debitedItem: {
        ...s.debitedItem,
        details: products,
        subtotal: subtotal_usd,
        discount: discountAmount,
        iva: iva_usd,
        igtf: igtf_usd,
        total: total_usd,
      },
      totals: {
        subtotal_without_disc_usd,
        subtotal_without_disc_bs,
        subtotal_usd,
        subtotal_bs,
        paid_usd,
        paid_bs,
        left_usd,
        left_bs,
        total_bs,
        total_usd,
        change_bs,
        change_usd,
        iva_bs,
        iva_usd,
        iva_8_bs,
        iva_8_usd,
        iva_16_bs,
        iva_16_usd,
        iva_31_bs,
        iva_31_usd,
        igtf_bs,
        igtf_usd,
        discount_bs: parse(discountAmount * exchangeRate),
        discount_usd: parse(discountAmount),
        diff_usd,
        diff_bs,
      }
    }));
  }

  render() {

    const { debitedItem, totals } = this.state;
    console.log('debitedItem: ', debitedItem)

    return (
      <div id="modal-create-debit">
        <div className="section">
          <p>Datos de factura y cliente</p>
        </div>

        <div className="modal-top">
          <div>
            <p>Cliente: {debitedItem?.order?.client?.name}</p>
            {!!debitedItem?.order?.client?.phone && (
              <p>Teléfono: {debitedItem?.order?.client?.phone}</p>
            )}
            {!!debitedItem?.order?.client?.email && (
              <p>Correo: {debitedItem?.order?.client?.email}</p>
            )}
            {!!debitedItem?.order?.client?.address && (
              <p>Dirección: {debitedItem?.order?.client?.address}</p>
            )}
            <p className="conversion">Tasa de cambio: Bs. {Globals.newFormatMiles(this.state.exchangeRate || 0, 4)}</p>
          </div>
          <div>
            <p>Fecha de emisión factura: {moment(debitedItem?.order?.created_at).format('DD-MM-YYYY HH:mm')}</p>
            <p>Forma de pago factura: {debitedItem?.order?.payment_methods_text}</p>
            <p>Fecha de emisión nota de débito: {moment(debitedItem?.created_at).format('DD-MM-YYYY HH:mm')}</p>
            <p>N° Nota de Débito: {debitedItem?.number_format}</p>
          </div>
        </div>

        <table border={1}>
          <thead>
            <tr>
              <td>Código</td>
              <td>Descripción del producto</td>
              <td align="right">Precio del producto (Bs)</td>
              <td>Cantidad</td>
              <td align="right">Neto</td>
            </tr>
          </thead>
          <tbody>
            {debitedItem?.details?.map((item, index) => (
              <tr key={index}>
                <td>{item?.product?.code}</td>
                <td>{item?.product?.name}</td>
                <td align="right">{Globals.formatMiles(item.price * debitedItem.conversion)}</td>
                <td align="center">{item.quantity}</td>
                <td align="right">Bs. {Globals.formatMiles(item.total * debitedItem.conversion)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="modal-bottom">
          <div>
            <div className="table-footer">
              <div className="date">
                <label>Fecha</label>
                <span>{moment(debitedItem.created_at).format('DD-MM-YYYY')}</span>
              </div>
              <div className="date">
                <label>Motivo de nota de débito</label>
                <span>{debitedItem?.motive || '-'}</span>
              </div>
            </div>

            <div className="table-footer">
              <div className="date">
                <label>Número de Factura</label>
                <span>{getBillNumber(debitedItem?.order) || '-'}</span>
              </div>
              <div className="date">
                <label>Método de pago</label>
                <span>{debitedItem?.payment_methods_text || '-'}</span>
              </div>
            </div>
          </div>

          <div className="totals">
            <div>
              <span>Sub-total</span>
              <span>Bs. {Globals.formatMiles(this.convert(debitedItem?.subtotal || 0))}</span>
            </div>
            <div>
              <span>% Desc</span>
              <span>
                <span>({Globals.formatMiles(debitedItem?.discount_percentage)}%) </span>
                <span>-Bs. {Globals.formatMiles(this.convert(debitedItem?.discount || 0))}</span>
              </span>
            </div>
            {debitedItem?.iva > 0 && (
              <div>
                <span>IVA (16%)</span>
                <span>Bs. {Globals.formatMiles(debitedItem?.iva_bs || 0)}</span>
              </div>
            )}
            {debitedItem?.igtf_bs > 0 && (
              <div>
                <span>IGTF</span>
                <span>Bs. {Globals.formatMiles(debitedItem?.igtf_bs || 0)}</span>
              </div>
            )}
            <div>
              <span>Total</span>
              <span>Bs. {Globals.formatMiles(this.convert(debitedItem?.total || 0))}</span>
            </div>
          </div>
        </div>

        <span className="increase-label">Aumento Total</span>
        <div className="increase-total">
          <span>Bs.</span>
          <input readOnly value={Globals.formatMiles(this.convert(debitedItem.total))} />
          <span>$</span>
          <input readOnly value={Globals.formatMiles(debitedItem.total)} />
        </div>
      </div>
    )
  }
}

export default connect(state => ({
  user: state.user,
}))(ModalViewDebit);